module.exports = __webpack_public_path__ + "06_medium_black.5682b0f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/06_medium_black.png
// module id = cyqZ
// module chunks = 0